import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BaseService {

    private http = inject(HttpClient);

    get<T>(url: string): Observable<T> {
        return this.http.get<T>(url);
    }

    getWithResponseType<T>(url: string, type: string = 'blob'): Observable<any> {
        return this.http.get<T>(url, { responseType: type as 'json' });
    }

    post<T>(url: string, data: any = null, options?: {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | string[] };
        responseType?: 'json';
    }): Observable<T> {
        return options ? this.http.post<T>(url, data, options) : this.http.post<T>(url, data);
    }

    postWithResponseType<T>(url: string, data: any, type: string = 'blob'): Observable<any> {
        return this.http.post<T>(url, data, { responseType: type as 'json' });
    }

    put<T>(url: string, data: any): Observable<T> {
        return this.http.put<T>(url, data);
    }

    patch<T>(url: string, data: any): Observable<T> {
        return this.http.patch<T>(url, data);
    }

    delete<T>(url: string): Observable<T> {
        return this.http.delete<T>(url);
    }
}
